import { Component } from 'react';
import BaseChart from 'legacy/javascripts/components/base_chart.es6';

class TagPerformance extends Component {
  render() {
    let options = {
      plugins: { legend: { display: false } },
      indexAxis: 'y',
      scales: {
        x: {
          ticks: { min: 0, max: this.props.max },
        },
      },
      doNotTranslateTooltipTitle: true,
    };

    return (
      <BaseChart
        type="bar"
        id="tagsTopAndBottom"
        labels={this.props.data.labels}
        datasets={this.props.data.datasets}
        options={options}
        labelParam="request_tags.raw"
        chartHandler={this.props.chartHandler}
      />
    );
  }
}

export default TagPerformance;
